// Para identificar el origen de la encuestra/evaluación
export enum EnumOrigenes
{
    Ninguno,
    Encuesta,
    Evaluacion
}